// Base Axios client — Document 8 will add auth interceptors
import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? ''

export const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
})

// Auth interceptor placeholder — Document 8 will inject WorkOS JWT
apiClient.interceptors.request.use((config) => {
  // TODO: Inject Authorization: Bearer <workos_token>
  return config
})

apiClient.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // TODO: Redirect to login — Document 8
    }
    return Promise.reject(error)
  }
)

export default apiClient
